import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import 'react-day-picker/lib/style.css';
import { DatepickerProvider } from './context';
import Datepicker from './Datepicker/Datepicker';
import { DATE_PICKER_TYPE, DEFAULT_DATE_FORMAT, isRangeSelectionDatePicker } from './utils/helper';
import '@dtsl/css-datepicker/dist/dayPickers.css';
import '@dtsl/css-utilities/dist/common-showcase/index.css';

// eslint-disable-next-line react/display-name
const DatepickerWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type = DATE_PICKER_TYPE.SINGLE_SELECTION,
    locale = 'en',
    month = new Date(),
    isOpen = false,
    setIsOpen = () => {},
    withInput = false,
    dateFormat = DEFAULT_DATE_FORMAT,
    handleOnClose = () => {},
    handleResetClick = () => {},
    setDisableConfirmButton = () => {},
    placeholder = '',
    setMonth = () => {},
    disabled = false,
    placement = 'bottomLeft',
    zIndex = `calc(var(--sib-z-index_modal, 1000) + 1)`,
    disablePlacementFlip = false,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(DatepickerProvider, {
    type: type,
    month: month,
    locale: locale,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    withInput: withInput,
    dateFormat: dateFormat,
    handleOnClose: handleOnClose,
    handleResetClick: handleResetClick,
    setDisableConfirmButton: setDisableConfirmButton,
    placeholder: placeholder,
    setMonth: setMonth,
    disabled: disabled,
    placement: placement,
    zIndex: zIndex,
    ref: ref,
    disablePlacementFlip: disablePlacementFlip
  }, /*#__PURE__*/React.createElement(Datepicker, restProps));
});
DatepickerWrapper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  month: PropTypes.instanceOf(Date),
  type: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  withInput: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  handleResetClick: PropTypes.func.isRequired,
  setDisableConfirmButton: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight']),
  setMonth: function (props, propName) {
    if (props['type'] && isRangeSelectionDatePicker(props['type']) && typeof props[propName] !== 'function') {
      return new Error(`prop ${propName} type of function must be supplied when using dates range picker.`);
    }
  },
  zIndex: PropTypes.string,
  disablePlacementFlip: PropTypes.bool
};
export default DatepickerWrapper;